import React from 'react';
import ReactDOM from 'react-dom';
import { CampaignHealthStatus } from './CampaignHealthStatus';

export interface CampaignHealthStatusPortalProps {
  campaignId: number;
  portalContainerIdPrefix?: string;
}

export function CampaignHealthStatusPortal({
  campaignId,
  portalContainerIdPrefix = 'ops',
}: CampaignHealthStatusPortalProps) {
  const element = document.getElementById(
    `${portalContainerIdPrefix}-campaign-status-${campaignId}`
  );

  const disabled = element.dataset.disabled === '1';

  return ReactDOM.createPortal(
    <CampaignHealthStatus
      campaignId={campaignId}
      disabled={disabled}
      justifyContent="center"
    />,
    element
  );
}
